import { Injectable } from '@angular/core';
import { TreeNode } from 'app-models';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FbModuleService {
  onLoadMenuList = new Subject<{
    moduleId: number,
    formBuilderInfo: any
  }>();
  onPageOpenSubject = new Subject<TreeNode>();
  
  constructor() { }

}
